import React, { useEffect, useRef, useState } from 'react'
import type { RawDraftContentBlock } from 'draft-js'
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'

interface TextViewDraftJSProps {
  text: string
  showSeeMoreButton?: boolean
}

export function TextViewDraftJS({
  text,
  showSeeMoreButton = true,
}: Readonly<TextViewDraftJSProps>) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const [mounted, setMounted] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)

  const draftState = EditorState.createWithContent(
    convertFromRaw(JSON.parse(text))
  )

  const rawContent = convertToRaw(draftState.getCurrentContent())

  rawContent.blocks = rawContent.blocks.map((block: RawDraftContentBlock) => {
    if (block.type === 'section') {
      return { ...block, type: 'unstyled' }
    }

    return block
  })

  const textHtml = draftToHtml(rawContent)

  useEffect(() => {
    setMounted(true)

    if (!showSeeMoreButton) {
      setShowButton(false)

      return
    }

    const el = contentRef.current

    if (!el) {
      setShowButton(false)

      return
    }

    const style = getComputedStyle(el)
    const lineHeight = parseFloat(style.lineHeight || '0')
    const maxHeight = lineHeight * 7

    setShowButton(el.scrollHeight > maxHeight)
  }, [showSeeMoreButton, textHtml])

  const containerStyle: React.CSSProperties =
    mounted && !isExpanded && showButton && showSeeMoreButton
      ? {
          display: '-webkit-box',
          WebkitLineClamp: 7,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'clip',
        }
      : {}

  return (
    <div>
      <div
        ref={contentRef}
        style={containerStyle}
        className="text-view-html text-base text-secondary font-inter font-normal leading-6"
        dangerouslySetInnerHTML={{ __html: textHtml }}
      />

      {showButton && (
        <button
          className="underline font-inter text-base font-normal text-restructure-action mt-4 underline-offset-[2px]"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? 'Mostrar menos' : 'Ver mais'}
        </button>
      )}
    </div>
  )
}
